import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TPricingStore,
	TAvailablePlansResponseData,
	TCurrentPlanResponseData,
	TRequestedPlanResponsePayload,
} from './types';

export const getPricingState = (state: TStoreState): TPricingStore => state.pricing;

export const getPricing = getPricingState;

// ==========================================:

export const getAvailablePlans = createSelector(
	[getPricing],
	(pricing: TPricingStore): TAvailablePlansResponseData => pricing.availablePlans,
);

// ==========================================:

export const getAvailablePlansLoader = createSelector(
	[getPricing],
	(pricing: TPricingStore): boolean => pricing.availablePlansLoader,
);

// ==========================================:

export const getCurrentPlan = createSelector(
	[getPricing],
	(pricing: TPricingStore): TCurrentPlanResponseData => pricing.currentPlan,
);

// ==========================================:

export const getCurrentPlanLoader = createSelector(
	[getPricing],
	(pricing: TPricingStore): boolean => pricing.currentPlanLoader,
);

// ==========================================:

export const getRequestedPlan = createSelector(
	[getPricing],
	(pricing: TPricingStore): TRequestedPlanResponsePayload => pricing.requestedPlan,
);

// ==========================================:

export const getRequestedPlanLoader = createSelector(
	[getPricing],
	(pricing: TPricingStore): boolean => pricing.requestedPlanLoader,
);
